<template>
  <section class="lms-container">
    <div class="content" style="margin-top:60px;">
      <div class="topic-title-content">
        <a href="/home/topics" class="back-button" style="font-size: 11px;">voltar</a>
        <div class="text-content">
          <h5 style="font-size: 14px;">{{topic.text}}</h5>

          <div class="topic-description">
            <span
              class="user-name"
            >Postado por {{topic.userName}} - {{getDate(topic.publishedOn)}}</span>
          </div>
        </div>
      </div>

      <div class="comments-content">
        <div class="new-comment-content" v-show="showCommentAnswer == false">
          <form id="49_create" name="49_create" v-on:submit.prevent="saveComment">
            <input
              v-model="newComment.text"
              type="text"
              name="comment.message"
              placeholder="Adicione um comentário..."
              required="true"
            />
            <button class="send-answer" type="submit">adicionar comentário</button>
          </form>
        </div>

        <h5 class="comments-title" style="font-size: 14px;">comentários</h5>

        <div v-for="comment in comments" :key="comment.id" class="comment" data-id="1835">
          <div class="comment-description">
            <span class="user-name">{{comment.userName}}</span>

            <span class="date-comment">- {{getDate(comment.registeredOn)}}</span>
          </div>

          <div class="text-content">
            <p style="font-size: 14px;">{{comment.text}}</p>
          </div>

          <div class="comment-status">
            <!-- <span class="option like">
              <span class="icon icon-thumb-up-2" title="Gostei"></span>
              <span class="number">0</span>
            </span>
            <span class="option unlike">
              <span class="icon icon-thumb-down-2" title="Não gostei"></span>
              <span class="number">0</span>
            </span>-->

            <button
              v-if="user.type==0 || ( comment.userId == user.id)"
              v-show="showCommentAnswer == false"
              class="answer-comment-button"
              @click="showCommentAnswer = true, currentComment = comment"
            >responder comentário</button>
            <button
              style="margin-left: 30px !important;"
              v-if="  user.type==0 || ( comment.userId == user.id)"
              v-show="showCommentAnswer == false"
              class="remove-comment"
              @click="removeComment(comment)"
            >remover comentário</button>
          </div>

          <div
            class="new-comment-content"
            v-if="showCommentAnswer == true && currentComment.id == comment.id"
          >
            <form id="58_create" name="58_create" v-on:submit.prevent="saveCommentAnswer">
              <input
                v-model="newCommentAnswer.text"
                type="text"
                name="currentComment.text"
                :placeholder="'Adicione uma resposta ao comentário de: ' + [[ comment.userName ]]"
                required="true"
              />
              <button class="send-answer" type="submit">Responder</button>
              <button
                class="cancel-answer"
                @click="showCommentAnswer = false, currentComment = {}"
              >cancelar</button>
            </form>
          </div>

          <h6
            class="comments-title"
            style="font-size: 10px;"
            v-if="comment.forumCommentAnswers.length > 0"
          >respostas do comentário de {{comment.userName}}</h6>
          <h6
            class="comments-title"
            style="font-size: 10px;"
            v-if="comment.forumCommentAnswers.length == 0"
          >nenhuma resposta para o comentário acima</h6>

          <div
            style="margin-left: 80px !important;"
            v-for="answerItem in comment.forumCommentAnswers"
            :key="answerItem.id"
            class="comment"
            data-id="1835"
          >
            <div class="comment-description">
              <span class="user-name">{{answerItem.userName}}</span>

              <span class="date-comment">- {{getDate(answerItem.registeredOn)}}</span>
            </div>

            <div class="text-content">
              <p style="font-size: 14px;">{{answerItem.text}}</p>
            </div>
          </div>

          <!-- <div class="new-comment-content reply" style="display: none;">
            <form name action="/aluno/turma/" method="POST">
              <input type="text" name="message" placeholder="Adicione uma resposta..." />
              <button class="send-answer" type="submit">responder</button>
              <button class="cancel-answer">cancelar</button>
            </form>
          </div>-->

          <!-- <div class="comment-children" style="display: none;"></div> -->
        </div>
      </div>
    </div>
  </section>
</template>


<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
  data() {
    return {
      user: this.$store.getters.user,
      saving: false,
      newComment: {},
      newCommentAnswer: {},
      comments: [],
      showCommentAnswer: false,
      currentComment: {}
    };
  },
  computed: mapState(["topic"]),
  components: {},
  methods: {
    saveComment() {
      this.newComment.topicId = this.topic.id;
      this.saving = true;
      console.log(this.newComment);
      const path = this.$global.endpoint + "/forum/comment/save";
      axios
        .post(path, {
          comment: this.newComment
        })
        .then(res => {
          this.saving = false;
          this.getAllComments();
          this.$notify({
            type: "success",
            group: "foo",
            title: "Concluído",
            text: "Tópico cadastrado com sucesso"
          });
          this.newComment = {};
        })
        .catch(error => {
          this.saving = false;
          console.error(error);
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: error.response.data.error
          });
        });
    },
    saveCommentAnswer() {
      console.log("chegou na funcao de salvar");
      this.newCommentAnswer.idForumComment = this.currentComment.id;
      this.saving = true;
      console.log("vou salvar a resposta do comentário");
      console.log(this.newCommentAnswer);
      const path = this.$global.endpoint + "/forum/commentanswer/save";
      axios
        .post(path, {
          comment: this.newCommentAnswer
        })
        .then(res => {
          this.saving = false;
          this.currentComment = {};
          this.showCommentAnswer = false;
          this.newCommentAnswer = {};
          this.getAllComments();
          this.$notify({
            type: "success",
            group: "foo",
            title: "Concluído",
            text: "Resposta ao comentário cadastrada com sucesso"
          });
          this.newComment = {};
        })
        .catch(error => {
          this.saving = false;
          console.error(error);
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: error.response.data.error
          });
        });
    },
    removeComment(comment) {
      this.saving = true;
      console.log(this.newComment);
      const path = this.$global.endpoint + "/forum/comment/remove";
      axios
        .post(path, {
          commentId: comment.id
        })
        .then(res => {
          this.saving = false;
          this.getAllComments();
          this.$notify({
            type: "success",
            group: "foo",
            title: "Concluído",
            text: "Comentário removido com sucesso"
          });
          this.newComment = {};
        })
        .catch(error => {
          this.saving = false;
          console.error(error);
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: error.response.data.error
          });
        });
    },
    getAllComments() {
      const path = this.$global.endpoint + "/forum/comment/getall";
      axios
        .post(path, {
          topicId: this.topic.id
        })
        .then(res => {
          this.comments = res.data;
          this.currentComment = {};
          this.showCommentAnswer = false;
        })
        .catch(error => {
          this.saving = false;
          console.error(error);
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: error.response.data.error
          });
        });
    },
     getDate(date){

      let d = new Date(new Date(date).setHours(new Date(date).getHours() - 3))
      d = `${(d.getDate() < 10 ? '0' + d.getDate() : d.getDate())}/${((d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1))}/${d.getFullYear()} ${(d.getHours() < 10 ? '0' + d.getHours() : d.getHours())}:${(d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes())}:${(d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds())}`;
      return d;
    }
  },
  created() {
    this.getAllComments();
  }
};
</script>
